import { Input, Directive } from '@angular/core';

@Directive()
export class FiWrapperTableCellBase<T> {
    @Input() value: T;
}
